import { UpdatableModel } from '../updatable-model';

export class Search<T> extends UpdatableModel<T> {
  sort?: any;
  pageNumber?: number;
  pageSize?: number;
}
